<template>
    <div>
      <p style="color:white;text-align:left;margin-left:5%;margin-top:0px">
      <el-select v-model="strategyId" placeholder="请选择" @change="changeStrategy" :style="{width:'4%'}" :class="[selectedStrategyState === 1 ? 'state-active' : (selectedStrategyState === 0 ? 'state-inactive' : '')]">
        <el-option
        v-for="item in strategys"
        :key="item.id"
        :label="item.name"
        :value="item.id"
        :style="{'color': item.state === 1 ? '#12ea81' : (item.state === 0 ? '#de1e1e' : 'inherit')}"
        />
      </el-select>
      <template v-if="$cookies.get('userName') === 'tantan6'">
      <el-dropdown trigger="click">
        <el-button class="action-strategy-buttons">策略操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="clearStrategyPosition(strategyId, strategyName)">清空仓位</el-dropdown-item>
            <el-dropdown-item @click.native="clearStrategyNotBTCPosition(strategyId, strategyName)">清空非BTC仓位</el-dropdown-item>
             <el-dropdown-item @click.native="clearStrategyAnyPosition(strategyId, strategyName)">清空任意币种仓位</el-dropdown-item>
            <el-dropdown-item @click.native="openStrategy(strategyId, strategyName)">开启策略</el-dropdown-item>
            <el-dropdown-item @click.native="closeStrategy(strategyId, strategyName)">关闭策略</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </template>
      <template v-else>
      <span style="margin-left:10px;margin-top:0px"></span>
      </template>
      <el-select v-model="apiId" placeholder="请选择" @change="changeApi" :style="{width:'8%'}" :class="[selectedApiState === 1 ? 'state-active' : (selectedApiState === 0 ? 'state-inactive' : '')]">
        <el-option
        v-for="item in apis"
        :key="item.id"
        :label="item.name"
        :value="item.id"
        :style="{'color': item.status === 1 ? '#12ea81' : (item.status === 0 ? '#de1e1e' : 'inherit')}"
        />
      </el-select>
      <el-dropdown trigger="click">
        <el-button class="action-buttons">API操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="followImmediately(apiId,apiName)">立即跟随</el-dropdown-item>
            <el-dropdown-item @click.native="clearPosition(apiId,apiName)">清空仓位</el-dropdown-item>
            <el-dropdown-item @click.native="follow(apiId,apiName)">跟随</el-dropdown-item>
            <el-dropdown-item @click.native="stopFollow(apiId,apiName)">停止跟随</el-dropdown-item>
            <el-dropdown-item @click.native="setStrategyStop(apiId,apiName,strategyId,1)">策略止损</el-dropdown-item>
            <el-dropdown-item @click.native="setStrategyStop(apiId,apiName,strategyId,0)">默认止损</el-dropdown-item>
            <template v-if="$cookies.get('userName') === 'tantan6'">
            <el-dropdown-item @click.native="changeFollow(apiId,apiName)">切换跟随</el-dropdown-item>
            </template>
        </el-dropdown-menu>
      </el-dropdown>
      API名称：{{ apiName }}，总价值：{{totalMoney}}，本期实时利润：{{profit}}，本期信号时间：{{signalTime}}，最新交易时间：{{tradingTime}}
      <button
          @click="showChart"
          style="margin-left: 10px; padding: 5px 15px; background: #409EFF; color: white; border: none; border-radius: 4px; cursor: pointer;"
        >
          资产曲线
        </button>
      </p>
         <div v-for="(item, index) in records" :key="index" class="simulate-list">
            <div>
                <el-table :data="item.l">
                    <el-table-column prop="symbol" label="币种(费率%)">
                    </el-table-column>
                    <el-table-column prop="quantity" label="多仓">
                    </el-table-column>
                    <el-table-column prop="money" label="市值">
                    </el-table-column>
                    <el-table-column prop="cost" label="成本">
                    </el-table-column>
                    <el-table-column prop="price" label="均价">
                    </el-table-column>
                    <el-table-column prop="prf" label="当期利润">
                    </el-table-column>
                    <el-table-column prop="prf_ratio" label="当期利润比%">
                        <template slot-scope="scope">
                            <span :class="getProfitClass(scope.row.prf_ratio)">
                                {{ scope.row.prf_ratio }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="profit" label="仓位利润">
                    </el-table-column>
                    <el-table-column prop="profit_ratio" label="仓位利润比%">
                        <template slot-scope="scope">
                            <span :class="getProfitClass(scope.row.profit_ratio)">
                                {{ scope.row.profit_ratio }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="profit_ratio" label="操作">
                        <template slot-scope="scope">
                            <button @click="closePositionAlone(scope.row.symbol)">平仓</button>
                        </template>
                    </el-table-column>
                </el-table>
                <p>
                    总市值：{{ lMoney }}，总币种数：{{lCost}}，均值：{{lMean}}，标准差：{{lStdev}}，完成时总市值：{{lFixed}}
                </p>
            </div>
            <div>
                <el-table :data="item.s" :style="{marginLeft: '19px'}">
                    <el-table-column prop="symbol" label="币种(费率%)">
                    </el-table-column>
                    <el-table-column prop="quantity" label="空仓">
                    </el-table-column>
                    <el-table-column prop="money" label="市值">
                    </el-table-column>
                    <el-table-column prop="cost" label="成本">
                    </el-table-column>
                    <el-table-column prop="price" label="均价">
                    </el-table-column>
                    <el-table-column prop="prf" label="当期利润">
                    </el-table-column>
                    <el-table-column prop="prf_ratio" label="当期利润比%">
                        <template slot-scope="scope">
                            <span :class="getProfitClass(scope.row.prf_ratio)">
                                {{ scope.row.prf_ratio }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="profit" label="仓位利润">
                    </el-table-column>
                    <el-table-column prop="profit_ratio" label="仓位利润比%">
                        <template slot-scope="scope">
                            <span :class="getProfitClass(scope.row.profit_ratio)">
                                {{ scope.row.profit_ratio }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="profit_ratio" label="操作">
                        <template slot-scope="scope">
                            <button @click="closePositionAlone(scope.row.symbol)">平仓</button>
                        </template>
                    </el-table-column>
                </el-table>
                <p>
                    总市值：{{ sMoney }}，总币种数：{{sCost}}，均值：{{sMean}}，标准差：{{sStdev}}，完成时总市值：{{sFixed}}
                </p>
            </div>
        </div>
        <div class="order-list">
            <el-table :data="orderList" height="510px">
                <el-table-column prop="symbol" label="币种">
                </el-table-column>
                <el-table-column prop="side" label="方向">
                </el-table-column>
                <el-table-column prop="send_price" label="委托价">
                </el-table-column>
                <el-table-column prop="send_quantity" label="委托量_R">
                </el-table-column>
                <el-table-column prop="send_volume" label="委托量_S">
                </el-table-column>
                <el-table-column prop="deal_price" label="成交价">
                </el-table-column>
                <el-table-column prop="deal_quantity" label="成交量">
                </el-table-column>
                <el-table-column prop="deal_money" label="成交额">
                </el-table-column>
                <el-table-column prop="status" label="状态">
                </el-table-column>
                <el-table-column prop="createtime" label="建单时间">
                </el-table-column>
                <el-table-column prop="updatetime" label="核实时间">
                </el-table-column>
            </el-table>
        </div>
        <el-pagination style="color:white" layout="prev, pager, next" :current-page="pagination.currentPage" :page-count="pagination.pageCount" @current-change="changePage"></el-pagination>
        <ChartModal :visible="showChartModal" :chartData="chartData" @close="showChartModal = false"/>
    <el-dialog title="切换跟随策略" :visible.sync="showChangeFollowDialog" width="400px" @close="closeSwitchDialog">
        <div style="margin: 20px 0;">
            <p style="margin-bottom: 10px; color: #666;">当前API：{{ currentSwitchApiName }}，请选择要切换的策略：</p>
            <el-radio-group v-model="selectedSwitchStrategy" style="width: 60%;">
                <div v-for="strategy in switchOptions" :key="strategy.id" style="margin-bottom: 10px; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px;">
                    <el-radio :label="strategy.id">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <span style="margin-right:5px;">{{ strategy.name }}</span>
                            <span :style="{color: strategy.state === 1 ? '#12ea81' : '#de1e1e'}">{{ strategy.state === 1 ? '运行中' : '已停止' }}</span>
                        </div>
                    </el-radio>
                </div>
            </el-radio-group>
            <div v-if="switchOptions.length === 0" style="text-align: center; color: #999; padding: 20px;">暂无其他可用策略</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeSwitchDialog">取 消</el-button>
            <el-button type="primary" @click="confirmSwitchFollow" :disabled="!selectedSwitchStrategy">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog
      title="清空任意币种仓位"
      :visible.sync="showClearAnyDialog"
      width="500px"
      @close="closeClearAnyDialog"
    >
      <div style="margin: 20px 0;">
        <p style="margin-bottom: 10px; color: #666;">
          策略：{{ clearStrategyName }}，请选择要清空的币种（可多选）：
        </p>
        <el-checkbox-group v-model="selectedClearCurrencies">
          <div
            v-for="item in clearAnyCurrencies"
            :key="item.symbol"
            style="margin-bottom: 10px; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px;"
          >
            <el-checkbox :label="item.symbol">
                <span>{{ item.fullSymbol }}</span>
            </el-checkbox>
          </div>
        </el-checkbox-group>
        <div v-if="clearAnyCurrencies.length === 0" style="text-align: center; color: #999; padding: 20px;">
           当前策略下无可操作币种
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeClearAnyDialog">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmClearAnyPosition"
          :disabled="selectedClearCurrencies.length === 0"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    </div>
</template>
<script>
    import { getBinanceData,
             getOrderData,
             getApi,
             getStrategy,
             independentTrigger,
             independentStrategyTrigger,
             independentStrategyPosition,
             changeTask,
             manuallyAdjustPosition,
             getChartData,
             switchFollowStrategy,
             changeStrategyState,
             independentStrategyClearCurrencies,
             getStrategyCurrency,
             strategyStop
    } from '@/api/api.js'
    import * as dayjs from 'dayjs'
    import ChartModal from './ChartModal.vue'

    export default {
        components: {
            ChartModal  // 注册弹窗组件
        },
        data() {
            return {
                showChangeFollowDialog: false,  // 新增：控制切换跟随弹窗显示
                switchOptions: [],              // 新增：切换选项列表
                selectedSwitchStrategy: null,   // 新增：选中的切换策略ID
                currentSwitchApiId: null,       // 新增：当前要切换的API ID
                currentSwitchApiName: '',       // 新增：当前要切换的API名称
                showChartModal: false,  // 控制弹窗显示
                chartData: {            // 图表数据
                    time: [],
                    earnings: [],
                    ratios:[]
                },
                strategys:[],
                strategyId:0,
                apiId:0,
                apiName:'',
                apiStatus:0,
                strategyName:'',
                records: [],
                apis:[],
                orderList:[],
                interval: '',
                lMoney: 0,
                sMoney: 0,
                totalMoney: 0,
                sCost: 0,
                lCost: 0,
                lMean:0,
                sMean:0,
                lStdev:0,
                sStdev:0,
                lFixed:0,
                sFixed:0,
                profit:0,
                signalTime:'',
                tradingTime:'',
                pagination: {
                    currentPage: 1,
                    pageCount: 0
                },
                showClearAnyDialog: false,
      clearAnyCurrencies: [],          // 可选币种列表
      selectedClearCurrencies: [],     // 用户选中的币种（数组）
      clearStrategyId: null,           // 当前策略ID
      clearStrategyName: ''            // 当前策略名称
            }
        },
        created() {
            this.strategyList().then(() => {
                this.apiList().then(() => {
                    this.getList();
                    this.getOrder();
                    this.startPolling();
                });
            });
        },
         computed: {
            selectedStrategyState() {
              if (!this.strategyId || !this.strategys || this.strategys.length === 0) return null;
              const selectedItem = this.strategys.find(item => item.id === this.strategyId);
              return selectedItem ? selectedItem.state : null;
            },
            selectedApiState() {
              if (!this.apiId || !this.apis || this.apis.length === 0) return null;
              const selectedItem = this.apis.find(item => item.id === this.apiId);
              return selectedItem ? selectedItem.status : null;
            }
          },
        methods: {
            closePositionAlone(currency){
                 currency = currency.split("(")[0];
                 this.$confirm(this.apiName + '：是否清空' + currency + '仓位?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    manuallyAdjustPosition({
                        token:this.$cookies.get('token'),
                        apiId: this.apiId,
                        currency:currency
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            // 正负值 颜色判断
            getProfitClass(prof) {
                 if (prof > 0) return 'negativeColor';
                 if (prof < 0) return 'positiveColor';
            },
            // 新增：开始轮询的方法
            startPolling() {
                // 先清除可能存在的旧定时器
                this.stopPolling();
                // 每20秒执行一次getList
                this.pollingTimer = setInterval(() => {
                    this.getList();
                }, 20000);
            },
            // 新增：停止轮询的方法
            stopPolling() {
                if (this.pollingTimer) {
                    clearInterval(this.pollingTimer);
                    this.pollingTimer = null;
                }
            },
            getChart() {
                getChartData({
                    apiId:this.apiId
                }).then(res => {
                    if (res.code === 200) {
                        this.chartData.time = res.data.days_list;
                        this.chartData.earnings = res.data.queity_list;
                        this.chartData.ratios = res.data.ratio_list;
                        }
                })
            },
            showChart() {
                this.showChartModal = true;
                this.getChart();
            },
            getList() {
                getBinanceData({
                    apiId:this.apiId
                }).then(res => {
                  if (res.code === 200) {
                    this.records = res.data.list;
                    this.apiName = res.data.api_name;
                    this.lMoney = res.data.l_money;
                    this.sMoney = res.data.s_money;
                    this.totalMoney = res.data.queity;
                    this.sCost = res.data.s_cost;
                    this.lCost = res.data.l_cost;
                    this.lMean = res.data.mean_stdev.l.mean;
                    this.sMean = res.data.mean_stdev.s.mean;
                    this.lStdev = res.data.mean_stdev.l.stdev;
                    this.sStdev = res.data.mean_stdev.s.stdev;
                    this.lFixed = res.data.fixed_money.l;
                    this.sFixed = res.data.fixed_money.s;
                    this.signalTime = res.data.signal_time;
                    this.tradingTime = res.data.trading_time;
                    this.profit = res.data.profit;
                    } else {
                        this.records = [];
                        this.apiName = '';
                        this.lMoney = 0;
                        this.sMoney = 0;
                        this.totalMoney = 0;
                        this.sCost = 0;
                        this.lCost = 0;
                        this.lMean = 0;
                        this.sMean = 0;
                        this.lStdev = 0;
                        this.sStdev = 0;
                        this.lFixed = 0;
                        this.sFixed = 0;
                        this.signalTime = '';
                        this.tradingTime = '';
                        this.profit = 0;
                    }
                })
            },
            apiList() {
               return getApi({strategyId:this.strategyId}).then(res => {
                    if (res.code === 200) {
                        this.apis = res.data.list_data;
                        if (this.apis.length > 0) {
                            this.apiId = this.apis[0].id;
                            this.apiName = this.apis[0].name;
                            this.apiStatus = this.apis[0].status;
                        } else {
                            this.apiId = 0;
                            this.apiName = '';
                            this.apiStatus = 0;
                        }
                    this.getList();
                    this.getOrder();
                    }
                })
            },
            strategyList() {
               return getStrategy().then(res => {
                    if (res.code === 200) {
                        this.strategys = res.data.list_data;
                        if (this.strategys.length > 0) {
                            this.strategyId = this.strategys[1].id;
                            this.strategyName = this.strategys[1].name;
                        } else {
                            this.strategyId = 0;
                            this.strategyName = '';
                        }
                    this.apiList();
                    }
                })
            },
            getOrder() {
                getOrderData({
                    apiId:this.apiId,
                    page: this.pagination.currentPage,
                    number: 20
                }).then(res => {
                    if (res.code === 200) {
                        this.orderList = res.data.list_data;
                        this.pagination.pageCount = res.data.total_pages;
                    }
                })
            },
            followImmediately(id) {
                this.$confirm(this.apiName + '：是否立即跟随(根据上次信号立即交易且跟随)?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    independentTrigger({
                        token:this.$cookies.get('token'),
                        isFollowImmediately: 1,
                        apiId: id
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            clearPosition(id) {
                this.$confirm(this.apiName + '：是否清空仓位?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    independentTrigger({
                        token:this.$cookies.get('token'),
                        apiId: id
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            setStrategyStop(aid,value,sid,target) {
                let targetStr = "默认止损"
                if (target === 1) {
                    targetStr = "策略止损"
                }
                this.$confirm('API：' + value + '绑定在' + this.strategyName + '策略下，是否设置成' + targetStr +'?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    strategyStop({
                        token:this.$cookies.get('token'),
                        strategyId: sid,
                        apiId: aid,
                        state:target
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            clearStrategyPosition(id) {
                this.$confirm(this.strategyName + '：是否清空策略已绑定API所有仓位?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    independentStrategyTrigger({
                        token:this.$cookies.get('token'),
                        strategyId: id
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            clearStrategyNotBTCPosition(id) {
                this.$confirm(this.strategyName + '：是否清空策略已绑定API中非BTC的仓位?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    independentStrategyPosition({
                        token:this.$cookies.get('token'),
                        strategyId: id
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            openStrategy(id) {
                this.$confirm(this.strategyName + '：是否开启此策略?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    changeStrategyState({
                        token:this.$cookies.get('token'),
                        strategyId: id,
                        state:1
                    }).then(res => {
                        if (res.code == 200) {
                            this.strategyList();
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            closeStrategy(id) {
                this.$confirm(this.strategyName + '：是否关闭此策略?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    changeStrategyState({
                        token:this.$cookies.get('token'),
                        strategyId: id,
                        state:0
                    }).then(res => {
                        if (res.code == 200) {
                            this.strategyList();
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            stopFollow(id) {
                this.$confirm(this.apiName + '：是否停止跟随?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    changeTask({
                        token:this.$cookies.get('token'),
                        apiId: id,
                        status:0
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            follow(id) {
                this.$confirm(this.apiName + '：是否跟随(下次信号触发才交易)?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    changeTask({
                        token:this.$cookies.get('token'),
                        apiId: id,
                        status:1
                    }).then(res => {
                        if (res.code == 200) {
                            this.$notify.info({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        } else {
                            this.$notify.error({
                                message: res.message,
                                title: '提示',
                                offset: 100
                            });
                        }
                    })
                }).catch(() => {

                })
            },
            changePage(value) {
                this.pagination.currentPage = value
                this.getOrder()
            },
            changeFollow(apiId, apiName) {
                this.currentSwitchApiId = apiId;
                this.currentSwitchApiName = apiName;
                // 过滤掉当前策略，生成切换选项
                this.switchOptions = this.strategys.filter(strategy =>
                    strategy.id !== this.strategyId
                );
                // 重置选择
                this.selectedSwitchStrategy = null;
                // 打开弹窗
                this.showChangeFollowDialog = true;
            },
            confirmSwitchFollow() {
                if (!this.selectedSwitchStrategy) {
                    this.$message.warning('请先选择一个策略');
                    return;
                }
                const selectedStrategy = this.strategys.find(
                    s => s.id === this.selectedSwitchStrategy
                );
                if (!selectedStrategy) {
                    this.$message.error('选择的策略不存在');
                    return;
                }
                this.$confirm(`确认将 ${this.currentSwitchApiName} 切换到 ${selectedStrategy.name} 策略吗？`, '确认切换', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.executeSwitchFollow(selectedStrategy);
                }).catch(() => {
                    // 用户取消操作
                });
            },
            executeSwitchFollow(selectedStrategy) {
                // 这里调用实际的切换跟随API
                // 假设有一个 switchFollowStrategy 的API
                switchFollowStrategy({
                    token: this.$cookies.get('token'),
                    apiId: this.currentSwitchApiId,
                    newStrategyId: selectedStrategy.id
                }).then(res => {
                    if (res.code === 200) {
                        this.$notify.success({
                            message: `已成功切换到 ${selectedStrategy.name} 策略`,
                            title: '成功',
                            offset: 100
                        });
                        // 关闭弹窗
                        this.showChangeFollowDialog = false;
                        // 刷新数据
                        this.apiList().then(() => {
                            this.startPolling();
                        });
                    } else {
                        this.$notify.error({
                            message: res.message || '切换失败',
                            title: '错误',
                            offset: 100
                        });
                    }
                    }).catch(error => {
                    console.error('切换跟随失败:', error);
                    this.$notify.error({
                        message: '切换失败，请稍后重试',
                        title: '错误',
                        offset: 100
                    });
                });
            },
            closeSwitchDialog() {
                this.showChangeFollowDialog = false;
                this.selectedSwitchStrategy = null;
                this.currentSwitchApiId = null;
                this.currentSwitchApiName = '';
            },
            changeApi(value) {
                const selectedApi = this.apis.find(item => item.id === value);
                this.apiId = value;
                this.apiName = selectedApi ? selectedApi.name : '';
                this.getList()
                this.getOrder()
                this.startPolling();
            },
            changeStrategy(value) {
                const selectedStrategy = this.strategys.find(item => item.id === value);
                this.strategyId = value;
                this.strategyName = selectedStrategy ? selectedStrategy.name : '';
                this.apiList().then(() => {
                    this.startPolling(); // 重启轮询
                });
            },
            dayjsFn(...args) {
                return dayjs(...args)
            },
            clearStrategyAnyPosition(id, name) {
              this.clearStrategyId = id
              this.clearStrategyName = name
              this.selectedClearCurrencies = []
              getStrategyCurrency({ strategyId: id }).then(res => {
                if (res.code === 200 && Array.isArray(res.data)) {
                  // 将后端返回的 [{name: 'BTC'}, {name: 'ETH'}] 转换为弹窗所需格式
                  this.clearAnyCurrencies = res.data.map(item => ({
                    symbol: item.name,        // 作为 checkbox 的 label 值
                    fullSymbol: item.name     // 显示用的名称（如果需要可自定义）
                  }))
                  this.showClearAnyDialog = true
                } else {
                  this.$message.error('获取币种列表失败或暂无币种')
                }
              }).catch(err => {
                console.error('获取币种列表失败', err)
                this.$message.error('获取币种列表失败')
              })
            },
    confirmClearAnyPosition() {
      if (this.selectedClearCurrencies.length === 0) {
        this.$message.warning('请至少选择一个币种')
        return
      }

      this.$confirm(
        `确认清空策略“${this.clearStrategyName}”中以下币种的仓位：${this.selectedClearCurrencies.join('、')}？`,
        '确认清仓',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          // 假设后端有策略级别清空指定币种的接口
          independentStrategyClearCurrencies({
            token: this.$cookies.get('token'),
            strategyId: this.clearStrategyId,
            currencies: this.selectedClearCurrencies // 后端应支持数组
          })
            .then(res => {
              if (res.code === 200) {
                this.$notify.success({
                  message: '指定币种清仓成功',
                  title: '成功',
                  offset: 100
                })
                this.closeClearAnyDialog()
                // 刷新当前API的持仓数据（若清仓影响多个API，可能需要更全面的刷新）
                this.getList()
                // 同时刷新策略列表（状态可能变化）
                this.strategyList()
              } else {
                this.$notify.error({
                  message: res.message || '清仓失败',
                  title: '错误',
                  offset: 100
                })
              }
            })
            .catch(error => {
              console.error('清仓失败:', error)
              this.$notify.error({
                message: '清仓失败，请稍后重试',
                title: '错误',
                offset: 100
              })
            })
        })
        .catch(() => {}) // 用户取消
    },
    closeClearAnyDialog() {
      this.showClearAnyDialog = false
      this.clearAnyCurrencies = []
      this.selectedClearCurrencies = []
      this.clearStrategyId = null
      this.clearStrategyName = ''
    }
        }
    }
</script>
<style scoped lang="scss">
::v-deep .state-active .el-input__inner {
  color: #12ea81 !important;
}

::v-deep .state-inactive .el-input__inner {
  color: #de1e1e !important;
}
.positiveColor{
   color: #1AB394;
}

.negativeColor{
    color: #F8AC59;
}

.simulate-list {
    display: flex;
    justify-content: center;
    p {
        color: #fff;
    }
    >div {
        flex: 0 0 47%;
        overflow: hidden;
    }
    ::v-deep .el-table {
        background-color: transparent;
        text-align: center;
        font-size: inherit;
        &:first-child {
            margin-right: 8px;
        }
        &::before {
            background-color: transparent;
        }

        tr,
        td,
        th {
            text-align: center;
            background-color: transparent;
        }

        th {
            color: #999;
            height: 20px;
            font-size: 11px;

            &.el-table__cell {
                border-bottom: none;
            }
        }

        td {
            padding: 0;

            .cell {
                padding: 0;
            }
        }

        .el-table__row {
            .el-table__cell {
                border-bottom: none;
            }

            &:hover {
                background-color: transparent;

                .el-table__cell {
                    background-color: rgba(#000, 0.1);
                }
            }
        }

        .el-table__body-wrapper {
            &::-webkit-scrollbar {
                background-color: #333;
                border-radius: 10px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #3f3e3e;
                border-radius: 10px;
                transition: all .2s ease-in-out;
            }

            &::-webkit-scrollbar-track {
                color: #0003;
                border-radius: 10px;
            }

            &::-webkit-scrollbar-corner {
                background-color: transparent;
            }
        }
        
    }
    
}
.action-buttons {
  padding:5px 10px;
  font-size:12px;
  margin-left: 10px;
  margin-right: 65px;
}
.action-strategy-buttons {
  padding:5px 10px;
  font-size:12px;
  margin-left: 10px;
  margin-right: 15px;
}
.order-list {
    display: flex;
    justify-content: center;
    p {
        color: #fff;
    }
    >div {
        flex: 0 0 93%;
        overflow: hidden;
    }
    ::v-deep .el-table {
        background-color: transparent;
        text-align: center;
        font-size: inherit;
        &:first-child {
            margin-right: 30px;
        }
        &::before {
            background-color: transparent;
        }

        tr,
        td,
        th {
            text-align: center;
            background-color: transparent;
        }

        th {
            color: #999;
            height: 20px;
            font-size: 12px;

            &.el-table__cell {
                border-bottom: none;
            }
        }

        td {
            padding: 0;
            .cell {
                padding: 0;
            }
        }

        .el-table__row {
            .el-table__cell {
                border-bottom: none;
            }

            &:hover {
                background-color: transparent;

                .el-table__cell {
                    background-color: rgba(#000, 0.1);
                }
            }
        }

        .el-table__body-wrapper {
            &::-webkit-scrollbar {
                background-color: #333;
                border-radius: 10px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #3f3e3e;
                border-radius: 10px;
                transition: all .2s ease-in-out;
            }

            &::-webkit-scrollbar-track {
                color: #0003;
                border-radius: 10px;
            }

            &::-webkit-scrollbar-corner {
                background-color: transparent;
            }
        }

    }

}

::v-deep .el-pagination {
    background-color: transparent;
    button, li {
        background-color: transparent;
    }
}
</style>